import { Subscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { OnboardingRequest } from './request';
import { SafePromise } from '@benzinga/safe-await';
import {
  IterableWorkflowRequest,
  IterableWorkflowResponse,
  MarketInterestResponse,
  OnboardingDataResponse,
  OnboardingUserQuestionsPayload,
  PortfolioResponse,
} from './entities';
import { OnboardingEnvironment } from './environment';

interface OnboardingEvent {
  type: 'onboarding:event';
}

export class OnboardingManager extends Subscribable<OnboardingEvent> {
  private request: OnboardingRequest;
  private session: Session;

  constructor(session: Session) {
    super();
    this.request = new OnboardingRequest(session);
    this.session = session;
  }

  public static getName = () => 'benzinga-onboarding';

  public getFastLinkUrl = () => this.session.getEnvironment(OnboardingEnvironment).fastLinkUrl;

  public getFastLinkConfig = () => this.session.getEnvironment(OnboardingEnvironment).fastLinkConfig;

  public setMarketInterest = (
    interest: string,
    userHubspotId: string | undefined,
  ): SafePromise<MarketInterestResponse> => {
    return this.request.setMarketInterest(interest, userHubspotId);
  };

  public getPortfolioAccessToken = (): SafePromise<PortfolioResponse> => {
    return this.request.getPortfolioAccessToken();
  };

  public getOnboardingData = (): SafePromise<OnboardingDataResponse> => {
    return this.request.getOnboardingData();
  };

  public submitOnboardingUserQuestions = (body: OnboardingUserQuestionsPayload): SafePromise<unknown> => {
    return this.request.submitOnboardingUserQuestions(body);
  };

  public triggerIterableWorkflow = (body: IterableWorkflowRequest): SafePromise<IterableWorkflowResponse> => {
    return this.request.triggerIterableWorkflow(body);
  };
}
